class S3DViewer {
  constructor(el) {
    if(typeof el == 'string' && document.querySelectorAll(el).length)
        this.el = document.querySelector(el)
    else
        this.el = el;
    
        window.addEventListener("message", this.handleMessage, false);
  }
  handleMessage ( event ) {
        if (event.origin.split('//')[1] == 'www.shape3d.com'){
            window._s3d_responses = window._s3d_responses || [] 
            window._s3d_responses.push( event.data )
        }
  }
  send ( what ) {
    this.el.contentWindow.postMessage(what,'*')
  }
  request (question) {
    this.send(question)
    var promise = new Promise(function(resolve) {
      setTimeout(resolve, 10);
    });
    
  }
  resolve (response) {
    console.log('resolve', response)
  }
  spin (speed) {
    this.send(`board.spin.start(${speed})`)
  }
  stop () {
    this.send(`board.spin.stop()`)
  }
  getPosition () {
    this.send(`board.position.report()`)
  }
  setPosition (p) {
    this.send(`board.position.set(${p})`)
  }
  setMode (mode) {
    this.send(`board.mode.set('${mode}')`)
  }
  theme (theme) {
    this.send(`style.theme(${JSON.stringify(theme)})`)  
  }
  style (query, property, value) {
    this.send(`style.set('${query}','${property}','${value}')`) 
  }
  controls (cmd) {
    this.send(`controls('${cmd}')`) 
  }
  camerea (cmd) {
    this.send(`camera('${cmd}')`) 
  }
}

/*
_n.qsa('iframe[src*=Viewer]').forEach(viewer=>{
  viewer.S3D = new S3DViewer(viewer)
})
_n.qsa('iframe[src*=Viewer]')[0].S3D.setMode('Horizontal')
*/